import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/user/companyyy/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/user/companyyy/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/user/companyyy/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/user/companyyy/submit',
    method: 'post',
    data: row
  })
}
export const yyStart = (data) => {
  return request({
    url: '/user/companyyy/yyStart',
    method: 'post',
    data: data
  })
}
export const batchYyStart = (ids, status) => {
  return request({
    url: '/user/companyyy/batchYyStart',
    method: 'post',
    params: {
      ids,
      status
    }
  })
}

export const companyYyModelExcel = (params) => {
  return request({
    url: '/user/companyyy/model',
    method: 'get',
    responseType: 'blob',
    params: {
      ...params
    }
  })
}
export const isValidYyCode = (yyCode, id) => {
  return request({
    url: '/user/companyyy/check/yyCode',
    method: 'get',
    params: {
      yyCode,
      id
    }
  })
}

